import React from 'react';
import complementosResumenList from './ComplementosResumenList';

const ComplementoResumen = ({ name, data, onEdit, onDelete }) => {
  const Complemento = complementosResumenList[name];

  if (!Complemento || !data) {
    return null;
  }

  return (
    <div className="py-3">
      <Complemento
        name={ name }
        data={ data }
        onEdit={ onEdit }
        onDelete={ onDelete }
      />
    </div>
  )
}

const ComplementosResumen = ({ data = {}, onEdit, onDelete }) => {
  const keys = Object.keys(data);

  const renderComplemento = (name) => {
    return (
      <ComplementoResumen
        key={ name }
        name={ name }
        data={ data[name] }
        onEdit={ onEdit }
        onDelete={ onDelete }
      />
    );
  }

  return (
    <div>
      { keys.map(renderComplemento) }
    </div>
  )
}

export default ComplementosResumen;
